import React, {Component} from 'react'
import FinanceTable from 'containers/tables/FinanceTable'

import {
	PanelWrapper,
	Tab,
	Tabs,
  Table,
} from 'components/UI'

class Finance extends Component {
  constructor(props){
    super(props)
  }

  render(){
    return(
      <PanelWrapper title={__('Financial Management', 'finance')}>
        <Tabs>
          <FinanceTable type='all_record'/>
        </Tabs>
      </PanelWrapper>
    )
  }
}

export default Finance



// WEBPACK FOOTER //
// ./src/containers/pages/Finance/index.js